<template>
    <input
        ref="input"
        type="radio"
        :value="value" v-model="model">
</template>

<script>

import {isNil} from "lodash";
import FormInput from "@/Mixins/FormInput";

export default {

    name: "Radio",

    mixins: [FormInput],

    inheritAttrs: false,

    props: {
        value: {}
    },

    methods: {
        mainElement() {
            return this.$refs.input;
        },
    }
};

</script>
